export default __webpack_public_path__ + "static/media/Rastech-update-8.9977ad1a.jpg";